import { render, staticRenderFns } from "./PlatformDashboard.vue?vue&type=template&id=cd14907e"
import script from "./PlatformDashboard.vue?vue&type=script&lang=js"
export * from "./PlatformDashboard.vue?vue&type=script&lang=js"
import style0 from "./PlatformDashboard.vue?vue&type=style&index=0&id=cd14907e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports